import React from 'react';
import KycAndPmla from '../components/kyc-and-pmla';

const KycAndPmlaPage = () => {
  return <KycAndPmla />;
};

export default KycAndPmlaPage;
